var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"outlined":"","color":_vm.color}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icone)+" ")]),_c(_setup.SInfoMontant,{attrs:{"colorisation":"","montant":_vm.opAjustement.montant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }